import Nav from "./../Page/Share/Nav/Nav";
const Post26 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Uporova Brand Guideline
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/41e7fb146388751.62aff80e2a3cc.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/bd6523146388751.62aff80e28c50.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/5e6f51146388751.62aff80e2b09e.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/26d784146388751.62aff80e29b7e.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/8ab1fc146388751.62aff80e26c90.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/2c0c5b146388751.62aff80e2797d.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/2cb427146388751.62aff80e2b896.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/4c4d4a146388751.62aff80e2a903.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/2800_opt_1/2cc951146388751.62aff80e27f80.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/2800_opt_1/061463146388751.62aff80e286c6.jpg" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/2800_opt_1/bed7c8146388751.62aff80e2bdab.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/2800_opt_1/4ed893146388751.62aff80e29455.jpg" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post26;
